export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_CONTRACTS":
      return action.payload;
    default:
      return state;
  }
};
